import { useLocation } from 'react-router-dom';

const departmentRoutes = {
  '/genie-civil': 'civil',
  '/genie-electrique': 'electrique',
  '/genie-informatique': 'informatique',
  '/communication': 'marketing',
};

export const useCurrentDepartment = () => {
  const location = useLocation();
  
  // Parcourir les routes pour trouver le département correspondant
  for (const [route, dept] of Object.entries(departmentRoutes)) {
    if (location.pathname.startsWith(route)) {
      return dept;
    }
  }
  
  return 'informatique'; // Défaut
};